export default __webpack_public_path__ + "static/media/Blacksulphur Sash.eb0a5dfc.jpg";